export default {
  ru: {
    page_does_not_exist: 'Страница по данному адресу не существует.',
  },

  en: {
    page_does_not_exist: 'The page at this address does not exist.',
  },
}